module.exports = __webpack_public_path__ + "static/media/privacypolicy_2023_09_26.de5d4cee.htm";